import { render } from "./whoWillUse.vue?vue&type=template&id=d300d0ba&scoped=true"
import script from "./whoWillUse.vue?vue&type=script&lang=js"
export * from "./whoWillUse.vue?vue&type=script&lang=js"

import "./whoWillUse.vue?vue&type=style&index=0&id=d300d0ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d300d0ba"]])

export default __exports__